import { gql } from "@apollo/client";

export const createGrandParentMessage = gql`
  mutation createGrandParentMessage($input: TargetCommunicationInput!) {
    targetCommunication(input: $input) {
      id
      createdByUserId
      targetId
      message
      document {
        fileName
        key
        # url
        uploadUrl
      }
      gifUrl
    }
  }
`;

export const replyToGrandParentMessage = gql`
  mutation replyToGrandParentMessage($input: TargetMessageThreadInput!) {
    targetMessageThreadMutation(input: $input) {
      createdByUserId
      grandParentMessageId
      responseType
      message
    }
  }
`;

export const replyToParentMessage = gql`
  mutation replyToParentMessage($input: TargetMessageThreadInput!) {
    targetMessageThreadMutation(input: $input) {
      createdByUserId
      grandParentMessageId
      responseType
      message
      parentMessageId
    }
  }
`;

export const saveLikesForGrandParentMessage = gql`
  mutation saveLikesForReply($input: TargetCommunicationInput!) {
    targetCommunication(input: $input) {
      id
      responseType
      loveLikeResponse {
        isLiked
        userId
      }
    }
  }
`;

export const saveLikesForParentMessage = gql`
  mutation saveLikesForReply($input: TargetMessageThreadInput!) {
    targetMessageThreadMutation(input: $input) {
      id
      responseType
      createdByUserId
      loveLikeResponse {
        isLiked
        userId
      }
    }
  }
`;

export const addMessageAttachment = gql`
  mutation AddDocument($input: TargetMessageThreadInput!) {
    targetMessageThreadMutation(input: $input) {
      id
      document {
        uploadUrl
        url
      }
    }
  }
`;

export const removeMessageAttachment = gql`
  mutation RemoveDocument($input: TargetMessageThreadInput!) {
    targetMessageThreadMutation(input: $input) {
      id
    }
  }
`;

export const removeMessageAttachmentFromMainMessage = gql`
  mutation removeDocFromMainMessage($input: TargetCommunicationInput!) {
    targetCommunication(input: $input) {
      id
    }
  }
`;

export const addGifAttachment = gql`
  mutation RemoveDocument($input: TargetMessageThreadInput!) {
    targetMessageThreadMutation(input: $input) {
      id
    }
  }
`;

export const addGifToMainMessage = gql`
  mutation addGifToMainMessage($input: TargetCommunicationInput!) {
    targetCommunication(input: $input) {
      id
    }
  }
`;

export const clearNotifications = gql`
  mutation clearNotification(
    $companyId: ID!
    $userId: ID!
    $category: NotificationCategory
    $isClearAll: Boolean
  ) {
    clearNotification(
      companyId: $companyId
      userId: $userId
      notificationCategory: $category
      isClearAll: $isClearAll
    ) {
      id
    }
  }
`;

export const readNotifications = gql`
  mutation readNotification(
    $companyId: ID!
    $userId: ID!
    $category: NotificationCategory
    $isreadAll: Boolean
  ) {
    clearNotification(
      companyId: $companyId
      userId: $userId
      notificationCategory: $category
      isClearAll: $isreadAll
    ) {
      id
    }
  }
`;
